/* eslint-disable */
export const setWebpackPublicPath = path => __webpack_public_path__ = path;
